<template>
  <div id="tickets-purchased" class="module">
    <h1>Tickets Purchased</h1>

    <el-card class="box-card">
      <!-- <simplebar
        v-if="Orders"
        class="scroll-box"
        data-simplebar-auto-hide="false"
      > -->
      <el-table v-if="Orders" :data="Items" data-simplebar>
        <el-table-column label="Order" width="90">
          <template slot-scope="scope">
            #{{ scope.row.id }}
          </template>
        </el-table-column>

        <el-table-column prop="name" label="Product"></el-table-column>
      </el-table>
      <!-- </simplebar> -->

      <p v-else>
        You have not purchased any tickets yet.
      </p>
    </el-card>
  </div>
</template>

<script>
import _ from "lodash";
import ApolloTicketOrders from "@/graphql/Member/TicketOrders.gql";
// import "simplebar/dist/simplebar.min.css";

export default {
  name: "TicketOrders",
  components: {
    // simplebar: () => import("simplebar-vue")
  },
  asyncComputed: {
    Items() {
      const Orders = this.Orders;
      let Items = [];

      if (Orders === undefined) return false;

      Orders.map(Order => {
        Order.Items.map(Item => {
          if (Item.name.includes("Ticket")) {
            Items.push(Item);
          }
        });
      });

      return Items;
    }
  },
  apollo: {
    Orders: {
      query: ApolloTicketOrders,
      variables() {
        return {
          userEmail: this.$store.state.user.email
        };
      },
      update(data) {
        return data.User[0].Orders;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.scroll-box {
  height: 360px;
}

.el-table {
  margin: 1rem 2rem 1rem 0;

  .simplebar-scrollbar:before {
    position: absolute;
    content: "";
    background: #00b6de;
  }
  /* &::-webkit-scrollbar {
		width: 1em;
	}
	&::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
	}
	&::-webkit-scrollbar-thumb {
		background-color: darkgrey;
		outline: 1px solid slategrey;

		// border: 7px solid #2BD8B6;
	} */
}
</style>
